var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFatigueAssessmentFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.645,
    height: 57.335,
    viewBox: "0 0 47.645 57.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.833V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 10.076)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.743V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 10.076) translate(11.136)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.833V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 20.151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.743V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 20.151) translate(11.136)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.833V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.743V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(11.136)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.833V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 30.228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.743V5.833H0z",
    transform: "translate(-388 -22) translate(394.894 34.727) translate(0 30.228) translate(11.136)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M46.644 57.335H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h45.644a1 1 0 0 1 1 1v55.335a1 1 0 0 1-1 1zM2.826 6.46v47.645h41.589V6.46z",
    transform: "translate(-388 -22) translate(388 22)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatigueAssessmentFilled);
export default __webpack_public_path__ + "static/media/fatigue-assessment-filled.4d18df8d729fd8a217e111c165e99930.svg";
export { ForwardRef as ReactComponent };